<template>
    <div id="grid-settings">
        <div>
            <label class="control-label cursor-pointer m-l-10 m-r-5" @click="showSettings">
                <i  style="width:15px;" class="fa fa-columns m-r-5"></i> Column Settings
            </label>

            <!--<button-->
                    <!--type="button"-->
                    <!--class="btn btn-text"-->
                    <!--@click="showSettings"-->
            <!--&gt;<i class="fa fa-columns" aria-hidden="true"></i> Column Settings</button>-->
        </div>
        <!-- Modal -->
        <div ref="settings"
             class="modal fade grid-settings-modal"
             role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">

                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Results Grid Settings</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-scroll-area p-25">
                            <div class="columns-visibility row">
                                <div class="col-md-12">
                                    <div class="text-bold">Display Sample Basis</div>
                                    <input type="checkbox" id="setting-display-as-received" v-bind:checked="local_display.as_received" v-on:change="onDisplayChanged('as_received', $event.target.checked)" v-show="false">
                                    <label class="control-label add-pointer m-r-10" for="setting-display-as-received">
                                        <i  style="width:15px" class="fa fa-check-square-o" v-if="local_display.as_received"></i>
                                        <i  style="width:15px" class="fa fa-square-o" v-else></i>
                                        As Received (AR)
                                    </label>
                                    <input type="checkbox" id="setting-display-dry-weight" v-bind:checked="local_display.dry_weight" v-on:change="onDisplayChanged('dry_weight', $event.target.checked)" v-show="false">
                                    <label class="control-label add-pointer" for="setting-display-dry-weight">
                                        <i  style="width:15px" class="fa fa-check-square-o" v-if="local_display.dry_weight"></i>
                                        <i  style="width:15px" class="fa fa-square-o" v-else></i>
                                        Dry Weight (DW)
                                    </label>
                                </div>
                            </div>
                            <hr>
                            <div class="columns-visibility row">
                                <div class="col-md-12">
                                    <label class="control-label cursor-pointer m-r-10" @click="unHideAllUnreportedColumns">
                                        <i style="width:15px;" class="fa fa-eye m-r-5"></i> Show All Columns
                                    </label>
                                    <label class="control-label cursor-pointer m-r-10" @click="hideAllUnreportedColumns">
                                        <i style="width:15px;" class="fa fa-eye-slash m-r-5"></i> Hide Columns with no Data
                                    </label>
                                </div>
                            </div>
                            <hr>
                        <div class="columns-order row">

                            <div class="master-columns col-md-12">
                                <div class="text-bold">Master Columns List</div>
                                <p>Instructions for color and row ordering section.</p>
                                <div v-show="is_retrieving_columns" id="results-loading">
                                    <div>
                                        <i class="fa fa-spin fa-spinner"></i>
                                    </div>
                                    <div>Loading...</div>
                                </div>
                                <div class="row columns-header">
                                    <div class="col-md-4">
                                        Column Name
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 text-center">
                                            <i class="fa fa-thumb-tack pinned"></i>
                                        </div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-0">Hide</div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-0">Clear</div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-1"></div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-2"></div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-3"></div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-4"></div>
                                    </div>
                                    <div class="col-md-1 p-lr-3">
                                        <div class="col-sm-12 color color-5"></div>
                                    </div>
                                </div>
                                <draggable :list="local_user_columns_order" class="master-drag-area" :options="{group:'columns'}" @changeColor="changeColor" v-show="! is_retrieving_columns" @change="onOrderChange">
                                    <div class="column-item row" v-for="(column, index) in local_user_columns_order" :key="index">
                                        <div class="col-md-4">
                                            <span class="fa fa-ellipsis-v m-r-5" style="color:#cacaca"></span>{{column.label}} {{column.units}} {{column.basis}}
                                        </div>
                                        <div class="col-md-1 p-lr-3">
                                            <div class="col-sm-12 text-center" @click="pinColumn(index)">
                                                <i class="fa fa-thumb-tack" :class="{ pinned: column.stick }"></i>
                                            </div>
                                        </div>
                                        <div class="col-md-1 p-lr-3">
                                            <div class="col-sm-12 text-center" @click="toggleHideColumn(index)">
                                                <i class="fa fa-stop-circle" :class="{ 'hidden-column': column.hidden }"></i>
                                            </div>
                                        </div>
                                        <div class="col-md-1"><div @click="changeColor(index,0)" class="color swatch color-0" v-bind:class="{ active: column.color == 0 }"></div></div>
                                        <div class="col-md-1"><div @click="changeColor(index,1)" class="color swatch color-1" v-bind:class="{ active: column.color == 1 }"></div></div>
                                        <div class="col-md-1"><div @click="changeColor(index,2)" class="color swatch color-2" v-bind:class="{ active: column.color == 2 }"></div></div>
                                        <div class="col-md-1"><div @click="changeColor(index,3)" class="color swatch color-3" v-bind:class="{ active: column.color == 3 }"></div></div>
                                        <div class="col-md-1"><div @click="changeColor(index,4)" class="color swatch color-4" v-bind:class="{ active: column.color == 4 }"></div></div>
                                        <div class="col-md-1"><div @click="changeColor(index,5)" class="color swatch color-5" v-bind:class="{ active: column.color == 5 }"></div></div>
                                    </div>
                                </draggable>
                            </div>

                        </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><span class="fa fa-times"></span> Close</button>
                        <button type="button" class="btn btn-lg btn-primary" @click="saveSettings"><span class="fa fa-check"></span> Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    // These are set here and inside table-item.vue
    // They need to be the same
    $column-color-0 : white;
    $column-color-1 : #dcedc8;
    $column-color-2 : #fff9c4;
    $column-color-3 : #cfd8dc;
    $column-color-4 : #ffcc80;
    $column-color-5 : #e1bee7;

    @import '../../sass/_global_variables.scss';

    .p-lr-3 {
        padding-left:3px;
        padding-right:3px;
    }

    #grid-settings{
        display:inline-block;
    }

    .grid-settings-modal {
        .fa-thumb-tack {
            transform: rotate(45deg);

            &:not(.pinned) {
                color: lighten($body-text, 50%);
            }
        }
        .fa-stop-circle {
            &:not(.hidden-column) {
                color: lighten($body-text, 50%);
            }
        }

        .modal-body {
            padding: 0px;
            .columns-order{
                //padding: 10px;
                .color{
                    &.active{
                        &.color-0{
                            background: $column-color-0;
                        }
                        &.color-1{
                            background: $column-color-1;
                        }
                        &.color-2{
                            background: $column-color-2;
                        }
                        &.color-3{
                            background: $column-color-3;
                        }
                        &.color-4{
                            background: $column-color-4;
                        }
                        &.color-5{
                            background: $column-color-5;
                        }
                    }
                    &.swatch{
                        border: 1px solid #cacaca;
                        border-radius: 2px;
                        width:40px;
                        height:25px;
                        cursor: pointer;
                    }

                }
                .columns-header{
                    font-weight: 700;
                    margin-bottom:10px;
                    .color{
                        min-height:24px;
                        &.color-0{
                            background: $column-color-0;
                        }
                        &.color-1{
                            background: $column-color-1;
                        }
                        &.color-2{
                            background: $column-color-2;
                        }
                        &.color-3{
                            background: $column-color-3;
                        }
                        &.color-4{
                            background: $column-color-4;
                        }
                        &.color-5{
                            background: $column-color-5;
                        }
                    }
                }
                .master-drag-area{
                    min-height: 50px;
                    padding-bottom:30px;
                    .column-item{
                        padding:5px 0px;
                        cursor:move;
                        &:hover{
                            //color: white;
                            background-color: #d9e6f7;
                         }
                    }
                }
            }
        }
    }

</style>
<script>
    import draggable from 'vuedraggable';
    export default {
        props: [
            'columns',
            'userColumnsOrder',
            'userDisplay'
        ],
        components: {
          draggable
        },
        data: function () {
            return {
                is_retrieving_columns: false,
                local_user_columns_order: [],
                settings: null,
                local_display : {
                    as_received: true,
                    dry_weight: true
                }
            }
        },
        methods: {
            onDisplayChanged(displayField, newValue) {
                this.$set(this.local_display, displayField, newValue);

                // Change hidden status of columns with the basis
                const basis = displayField === 'as_received' ? 'AR' :
                    displayField === 'dry_weight' ? 'DW' : '';

                // This shouldn't be possible, but still check to make sure we have a valid field change
                if (basis === '') {
                    return;
                }

                this.local_user_columns_order.forEach(column => {
                    if (column.basis === basis) {
                        column.hidden = !newValue;
                    }
                });
            },
            // This method is called AFTER a reordering in the draggable component
            onOrderChange(evt) {
                // I only care about moved events
                if (_.has(evt, "moved")) {
                    const moved = evt.moved;
                    const element = moved.element;

                    // If this element is not stick'ed (pinned)
                    if (element.stick === false) {
                        for (let i = this.local_user_columns_order.length - 1; i > moved.newIndex; --i) {
                            // if it has been dropped before the last pinned element
                            if (this.local_user_columns_order[i].stick === true) {
                                // If so, then also mark this element as pinned
                                element.stick = true;
                                break;
                            }
                        }
                    }
                }
            },
            addNewColumns () {
                // Loop through the columns from the report we are viewing now
                this.columns.forEach((new_column) => {
                    const existing_item = this.local_user_columns_order.find((column) => {
                        return column.label === new_column.label
                            && column.basis === new_column.basis
                            && column.units === new_column.units;
                    });
                    // If the column doesn't exist already in our master list of columns we will add this one
                    if (!existing_item) {
                        this.local_user_columns_order.push(new_column);
                    }
                });
            },
            showSettings () {
                this.settings.modal('show');
                // Use our user preferences
                this.local_user_columns_order = _.cloneDeep(this.userColumnsOrder);
                if (this.userDisplay) {
                    this.local_display = _.clone(this.userDisplay);
                }
                // Add all the columns from the current report
                this.addNewColumns();
            },
            saveSettings () {
                const columnsData = this.local_user_columns_order.map(function (column) {
                    return {
                        'label': column.label,
                        'basis': column.basis,
                        'units': column.units,
                        'color': column.color,
                        'stick': column.stick,
                        'hidden': column.hidden
                    };
                });

                this.$emit('save', this.local_user_columns_order, this.local_display);

                this.settings.modal('hide');
            },
            changeColor (index, color) {
                this.$set(this.local_user_columns_order[index], 'color', color);
            },
            pinColumn (index) {
                // Modify Column
                let column = this.local_user_columns_order[index];
                this.$set(column, 'stick', !column.stick);

                // Reorder columns
                let pinnedColumns = this.local_user_columns_order.filter(col => col.stick);
                let unPinnedColumns = this.local_user_columns_order.filter(col => !col.stick);
                this.local_user_columns_order = [...pinnedColumns, ...unPinnedColumns];
            },
            toggleHideColumn (index) {
                let column = this.local_user_columns_order[index];
                this.$set(column, 'hidden', !column.hidden);

                // Check Display Sample Basis to make sure it now still make sense
                const displayField = column.basis === 'AR' ? 'as_received' :
                    column.basis === 'DW' ? 'dry_weight' : '';

                if (displayField === '') {
                    return;
                }

                // If the field is now, not hidden, that means for certain that this display basis should appear enabled
                if (!column.hidden) {
                    this.$set(this.local_display, displayField, true);
                } else {
                    // If it's no longer hidden, we need to scan the rest of the columns with this basis to see if they are all also hidden, in which case, turn off the basis checkmark
                    this.$set(
                        this.local_display,
                        displayField,
                        !this.local_user_columns_order.filter(c => c.basis === column.basis).every(c => c.hidden)
                    );
                }
            },
            // Check every column and check to see if each row has data for that analyte, if not, mark as hidden
            hideAllUnreportedColumns() {
                // the columns prop is the only one that has the 'hasData' field
                // that's why we have to use that one to determine which columns in local_user_columns_order we need to hide
                this.columns.filter(col => !col.hasData).forEach(col => {
                    this.local_user_columns_order.filter(master_col =>
                        master_col.label === col.label
                        && master_col.basis === col.basis
                        && master_col.units === col.units
                    ).forEach(master_col => this.$set(master_col, 'hidden', true));
                });

                // Check to see which displays should now be checked off
                for (const [displayField, basis] in [['as_received', 'AR'], ['dry_weight', 'DW']]) {
                    const columnsWithBasis = this.local_user_columns_order.filter(c => c.basis === basis);
                    if (columnsWithBasis.length > 0) {
                        this.$set(
                            this.local_display,
                            displayField,
                            !columnsWithBasis.every(c => c.hidden)
                        );
                    }
                }
            },
            unHideAllUnreportedColumns() {
                this.local_user_columns_order.forEach(col => this.$set(col, 'hidden', false));
                this.$set(this.local_display, 'as_received', true);
                this.$set(this.local_display, 'dry_weight', true);
            }
        },
        mounted: function () {
            var vm = this;
            vm.settings = $(vm.$refs.settings);
            vm.settings.on('hidden.bs.modal', function() { vm.$emit('closed') });
            $('body').append(vm.settings);
        }
    }
</script>



// WEBPACK FOOTER //
// grid-settings.vue?7d65e05c